import { gql } from '@apollo/client';

export default gql`
  mutation DeletePC($input: deletePcInput) {
    deletePC(input: $input) {
      id
    }
  }
`;
